import { useCallback } from 'react';
import { getDocsConfig, isAnalyticsEnabled } from '../../shared/utils/config';
import { userService } from '../../auth/services/user.service';
import { appendTrackingParams } from '../utils';
import { User } from '../../auth/interfaces/user';
import { useAnalyticsTracker } from '../../tracking/hooks/useAnalyticsTracker';

interface UseDocLinkReturnType {
  getLinkURL: (path: string, section: string, properties?: object) => string;
  trackClick: (path: string, section: string, properties?: object) => void;
}

export function useDocLink(): UseDocLinkReturnType {
  const { eventTrack } = useAnalyticsTracker();

  const getLinkURL = useCallback((path: string, section: string, properties?: object) => {
    const docsConfig = getDocsConfig();

    if (typeof docsConfig === 'undefined') {
      return null;
    }

    const url: string = docsConfig.docsURL + path;

    if (
      isAnalyticsEnabled({
        enabled: docsConfig.enabled,
        enabledForHevo: docsConfig.enabledForHevo
      })
    ) {
      return appendTrackingParams(url, section, userService.getUser() as User, properties);
    }

    return url;
  }, []);

  const trackClick = (path: string, section: string, properties?: object) => {
    eventTrack({
      action: '[Docs] link click',
      properties: {
        path,
        section,
        ...properties
      }
    });
  };

  return <UseDocLinkReturnType>{
    getLinkURL,
    trackClick
  };
}
